import { render, staticRenderFns } from "./DetailPanel.vue?vue&type=template&id=3ba5a5d2&"
import script from "./DetailPanel.vue?vue&type=script&lang=js&"
export * from "./DetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports